export default {
  async fetch({ dispatch, commit }) {
    commit("SET_LOADING", true);
    try {
      await dispatch("setConfigs");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async setConfigs({ commit, state, rootGetters }) {
    const { page, sortBy, orderBy, search: filter } = state;
    const size = rootGetters["application/getPageSize"];
    try {
      const configs = await this.$services.config.fetch({ size, page, sortBy, orderBy, filter });
      commit("SET_CONFIGS", configs);
    } catch (error) {
      throw new Error(error);
    }
  },

  async setConfig({ commit }, config) {
    const { property, value, description, id } = config;
    try {
      const body = { property, value, description };
      const updatedConfig = await this.$services.config.update(id, body);
      commit("SET_CONFIG", updatedConfig);
      this.$feedback.ok("feedback.update.config.ok");
    } catch {
      this.$feedback.error("feedback.update.config.error");
    }
  },

  async fetchConfig({ commit }, id) {
    try {
      const data = await this.$services.config.fetchOne(id);
      commit("SET_EDITING_CONFIG", data);
    } catch (error) {
      throw new Error(error);
    }
  },
};
